import { Form } from 'react-bootstrap'

interface IItemProps {
    item: IGetAllPayment
    isSelected: boolean
    handleSelectSpecificPayment: (id: number) => void
}
export default function Item({
    item,
    isSelected,
    handleSelectSpecificPayment,
}: IItemProps) {
    return (
        <>
            <hr className=" my-3" />
            <div className=" my-2 flex justify-between">
                <p className=" text-sm">{item.description}</p>
                <Form.Check
                    type="checkbox"
                    id={`check-api-checkbox`}
                    className=" mx-2"
                >
                    <Form.Check.Input
                        type="checkbox"
                        isValid
                        checked={isSelected}
                        onChange={() => handleSelectSpecificPayment(item.id)}
                    />
                </Form.Check>
            </div>
            <p className=" text-gray-3">
                {Number(item.amount).toLocaleString()} تومان
            </p>
        </>
    )
}
